var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('Carousel'),_c('AboutUs',{attrs:{"hideShowMoreBtn":true}}),_c('ProductService'),_c('News'),_c('Partners',{attrs:{"titleText":'合作伙伴',"titleSubText":'PARTNERS'}}),_c('ContactInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }